import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

/**
 * Invisible reCAPTCHA for the OTP sign-in screens, plus the attribution that
 * stands in for Google's floating badge.
 *
 * WHY THE BADGE IS HIDDEN. With `size="invisible"` Google injects
 * `.grecaptcha-badge` into this component's own container rather than into
 * <body>, and on these screens it landed on top of the sign-in card — covering
 * the "Send OTP" button on the phone step and the "Change phone number" link on
 * the code step (reported 2026-08-27). Hiding it is Google's own documented
 * alternative and the only fix that does not depend on out-guessing where the
 * badge will position itself.
 *
 * ⚠️ The visible wording below is REQUIRED by the reCAPTCHA terms whenever the
 * badge is not shown. Do not remove it, and do not hide the badge on any other
 * screen without carrying this notice across too.
 *
 * Renders nothing at all when no site key is configured, so a local or CI build
 * without VITE_RECAPTCHA_SITE_KEY shows no dangling notice.
 */
const OtpCaptcha = ({ innerRef, enabled, siteKey }) => {
  if (!enabled) {
    return null;
  }

  return (
    <>
      {/* Zero-sized, out-of-flow host: the badge inside it is hidden by
          rc-auth.scss, and the challenge overlay (when one is required) is
          appended to <body> by Google, so it is unaffected by this. */}
      <div className="rc-captcha-host">
        <ReCAPTCHA ref={innerRef} size="invisible" sitekey={siteKey} />
      </div>

      <p className="small-text rc-captcha-notice">
        This site is protected by reCAPTCHA and the Google{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{" "}
        and{" "}
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>{" "}
        apply.
      </p>
    </>
  );
};

export default OtpCaptcha;
